const UPGRADABLE_PACKAGE_IDS = {
    development: ['ff8081817cef8b83017cffc0fa440000'],
    test: ['ff8081817cef8b83017cffc0fa440000'],
    production: ['ff8081817cef94a4017cff87d8150000'],
};

export default UPGRADABLE_PACKAGE_IDS[process.env.BUILD_ENV || process.env.REACT_APP_BUILD_ENV];
